module.exports = __webpack_public_path__ + "static/media/fontello.11de21fa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/fontello.ttf?8095705
// module id = 333
// module chunks = 0